"use client";
import { Drawer } from "@mui/material";
import Link from "next/link";
import React, { useState } from "react";
import { FaGamepad, FaGhost, FaNewspaper, FaPuzzlePiece } from "react-icons/fa";
import {
  FaAddressCard,
  FaCircleInfo,
  FaCommentDots,
  FaCookieBite,
  FaEnvelopeOpenText,
  FaFileContract,
  FaHouse,
  FaIcons,
  FaWarehouse,
} from "react-icons/fa6";
import ChangeOSComp from "./changeOScomp";

interface iProps {
  platform: string;
}

export default function MainMenuHamburger({ platform }: iProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const closeDrawer = () => {
    setIsOpen(false);
  };

  return (
    <>
      <ul className="list-none m-0 p-0 text-black">
        <li>
          <button
            title="Main Menu"
            aria-label="Main Menu"
            onClick={handleClick}
            className="bg-getjar-orange flex flex-col justify-center items-center h-8 w-8 p-2 rounded-md mt-[0px]"
          >
            <span
              className={`bg-white block transition-all duration-300 ease-out h-0.5 w-4 rounded-sm ${
                isOpen ? `rotate-45 translate-y-1` : `-translate-y-0.5`
              }`}
            ></span>
            <span
              className={`bg-white block transition-all duration-300 ease-out h-0.5 w-4 rounded-sm my-0.5 box-content ${
                isOpen ? `opacity-0` : `opacity-100`
              }`}
            ></span>
            <span
              className={`bg-white block transition-all duration-300 ease-out h-0.5 w-4 rounded-sm ${
                isOpen ? `-rotate-45 -translate-y-1` : `translate-y-0.5`
              }`}
            ></span>
          </button>
        </li>
      </ul>
      <Drawer anchor="right" open={isOpen} onClose={handleClick}>
        <div className="flex flex-col gap-1 p-4 w-[320px] text-black">
          <ChangeOSComp onOSSelect={closeDrawer}></ChangeOSComp>
          <Link
            href="/"
            title="GetJar.com"
            className="group flex items-center align-baseline hover:bg-getjar-darkorange p-2 rounded-md hover:text-white hover:no-underline"
            onClick={closeDrawer}
          >
            <FaHouse className="pr-1 group-hover:fill-white" /> Home
          </Link>
          <hr className="border-t-2 border-gray-300 my-1" />
          <Link
            href="/games/all"
            title="Play online games on GetJar.com"
            className="group flex items-center align-baseline hover:bg-getjar-darkorange p-2 rounded-md hover:text-white hover:no-underline"
            onClick={closeDrawer}
          >
            <FaGhost className="pr-1 group-hover:fill-white" /> Games
          </Link>
          <Link
            href="/articles"
            title="GetJar.com News and Articles"
            className="group flex items-center align-baseline hover:bg-getjar-darkorange p-2 rounded-md hover:text-white hover:no-underline"
            onClick={closeDrawer}
          >
            <FaNewspaper className="pr-1 group-hover:fill-white" /> News
          </Link>
          <Link
            href={`/${platform}`}
            title="GetJar Applications Categories"
            className="group flex items-center align-baseline hover:bg-getjar-darkorange p-2 rounded-md hover:text-white hover:no-underline"
            onClick={closeDrawer}
          >
            <FaPuzzlePiece className="pr-1 group-hover:fill-white" /> Categories
          </Link>

          <hr className="border-t-2 border-gray-300 my-2" />
          {/* Secondary Menu */}
          <Link
            href="/about"
            title="About GetJar.com"
            className="group flex items-center align-baseline mb-0 hover:bg-getjar-darkorange p-2 rounded-md hover:text-white hover:no-underline"
            onClick={closeDrawer}
          >
            <FaAddressCard className="pr-1 group-hover:fill-white" /> About Us
          </Link>
          {/* <Link
            href="/how-it-works"
            title="How it works"
            className="flex items-center align-baseline mb-1 hover:bg-getjar-darkorange p-2 rounded-md hover:text-white"
            onClick={closeDrawer}
          >
            <FaCircleInfo className="pr-1" /> How it works
          </Link>
          <Link
            href="/review"
            title="Write a review"
            className="flex items-center align-baseline mb-1 hover:bg-getjar-darkorange p-2 rounded-md hover:text-white"
            onClick={closeDrawer}
          >
            <FaCommentDots className="pr-1" /> Write a review
          </Link> */}
          <Link
            href="/info/terms"
            title="Terms and Conditions"
            className="group flex items-center align-baseline mb-0 hover:bg-getjar-darkorange p-2 rounded-md hover:text-white hover:no-underline"
            onClick={closeDrawer}
          >
            <FaFileContract className="pr-1 group-hover:fill-white" /> Terms and
            Conditions
          </Link>
          <Link
            href="/info/privacy"
            title="Privacy Policy"
            className="group flex items-center align-baseline mb-0 hover:bg-getjar-darkorange p-2 rounded-md hover:text-white hover:no-underline"
            onClick={closeDrawer}
          >
            <FaFileContract className="pr-1 group-hover:fill-white" /> Privacy
            Policy
          </Link>
          <Link
            href="/info/cookie"
            title="Cookie Policy"
            className="group flex items-center align-baseline mb-0 hover:bg-getjar-darkorange p-2 rounded-md hover:text-white hover:no-underline"
            onClick={closeDrawer}
          >
            <FaCookieBite className="pr-1 group-hover:fill-white" /> Cookie
            Policy
          </Link>
          <Link
            href="/contactus"
            title="Contact Us"
            className="group flex items-center align-baseline mb-1 hover:bg-getjar-darkorange p-2 rounded-md hover:text-white hover:no-underline"
            onClick={closeDrawer}
          >
            <FaEnvelopeOpenText className="group-hover:fill-white pr-1" />{" "}
            Contact
          </Link>
          {/* <Link
            href="/oem"
            title="GetJar AppStore Solutions"
            className="flex items-center align-baseline mb-1 hover:bg-getjar-darkorange p-2 rounded-md hover:text-white"
            onClick={closeDrawer}
          >
            <FaWarehouse className="pr-1" /> For OEMs
          </Link> */}
          {/* <Link   href="" title="">
            For Developers
          </Link> */}
        </div>
      </Drawer>
    </>
  );
}
